import { oppositePlayer } from 'features/board/utils'
import { DatabaseGame } from 'features/firebase/types'
import { isGameOpen } from 'features/game/utils'

export const getGamesStats = (playerId: string, games: DatabaseGame[]) => {
  let winCount = 0
  let drawCount = 0
  let loseCount = 0
  let whiteWins = 0
  let blackWins = 0

  games.forEach(game => {
    if (!game || isGameOpen(game.status)) return
    const myColor = game.players.white === playerId ? 'white' : 'black'

    if (game.result?.winner === myColor) {
      winCount++

      if (myColor === 'white') {
        whiteWins++
      } else {
        blackWins++
      }
    }

    if (game.result?.winner === 'draw') {
      drawCount++
    }

    if (game.result?.winner === oppositePlayer(myColor)) {
      loseCount++
    }
  })

  const totalGames = winCount + drawCount + loseCount
  const minTotalGames = Math.max(1, totalGames)
  const winPercentage = (winCount / minTotalGames) * 100
  const drawPercentage = (drawCount / minTotalGames) * 100
  const losePercentage = (loseCount / minTotalGames) * 100

  const totalWins = whiteWins + blackWins
  const minTotalWins = Math.max(1, totalWins)
  const whiteWinPercentage = (whiteWins / minTotalWins) * 100
  const blackWinPercentage = (blackWins / minTotalWins) * 100

  return {
    winCount,
    drawCount,
    loseCount,
    totalGames,
    winPercentage,
    drawPercentage,
    losePercentage,
    whiteWins,
    blackWins,
    whiteWinPercentage,
    blackWinPercentage,
  }
}

export const getUserInitials = (displayName?: string | null) =>
  (displayName || 'T E').split(' ').reduce((acc, item) => `${acc}${item[0].toUpperCase()}`, '')
